// @flow
import { connect } from 'react-redux'
import AdAccountSelect from './AdAccountSelect'
import type { Store } from '../../redux/ducks'
import type { State as AudienceState } from '../../redux/ducks/audienceEdit/reducers'
import getJson from '../../services/getJson'
import _ from 'lodash'
import { patch } from '../AudienceEditContainer'

const getCampaignOptionsUrl = '/api/v1/campaigns/campaign_options'

function mapStateToProps(state: Store) {
  const audienceState = state.audienceEdit
  const initial = audienceState.initial

  if (!initial) return {}

  return {
    options: audienceState.adAccountOptions,
    currentAdAccountId: audienceState.currentAdAccountId,
    adAccountErrors: audienceState.adAccountErrors
  }
}

function mapDispatchToProps(dispatch: Function) {
  return {
    onChange: (diff: $Shape<AudienceState>) => {
      patch(dispatch, diff)
      updateCampaignOptions(diff.currentAdAccountId, dispatch)
    }
  }
}

function updateCampaignOptions(id: number, dispatch: Function) {
  const data = {
    current_ad_account_id: id.toString()
  }

  getJson(getCampaignOptionsUrl, data)
    .then(({ data }) => {
      if (_.isEmpty(data)) {
        patch(dispatch, { campaignId: 0, campaignName: '' })
      } else {
        patch(dispatch, { campaignId: data[0].id, campaignName: data[0].name })
      }
      patch(dispatch, { campaignOptions: data, adAccountErrors: [], vkPublic: {}, fbPublic: {} })
    })
    .fail(() => {
      window.alert('Internal error')
    })
}

const AdAccountSelectContainer = connect<Object, Object, _, _, _, _>(
  mapStateToProps,
  mapDispatchToProps
)(AdAccountSelect)

export default AdAccountSelectContainer
